// actions/insights/sales/productsInsightsReport/ProductsInsightsReportActions.ts

import { ThunkAction } from 'redux-thunk';
import { AxiosResponse } from 'axios';
import store from 'store';
import ApiClient, { createTokenConfig, isCancelled } from 'api/ApiClient';
import { NotificationsAction, showError } from '@spike/notifications-action';

import type { ProductsInsightsReportDto } from './ProductsInsightsReportDto';
import { convertToProductsInsightsReport } from './productsInsightsReportConverter';

import {
    PRODUCTS_INSIGHTS_REPORT_GET_START,
    PRODUCTS_INSIGHTS_REPORT_GET_SUCCESS,
    PRODUCTS_INSIGHTS_REPORT_GET_ERROR,
    ProductsInsightsReportAction
} from './ProductsInsightsReportActionsTypes';

import type { ProductsInsightsReport } from 'model/ProductsInsightsReport';

export const getProductsInsightsReport = (
    start?: string,
    end?: string,
    page = 1,
    perPage = 10
): ThunkAction<void, null, null, ProductsInsightsReportAction | NotificationsAction> => {
    return async dispatch => {
        dispatch(getStart());

        const { marketplaceId, token } = store.getState().login.auth;

        let url = `/products_insights_report?marketplace_id=${marketplaceId}`;
        if (start) url += `&start=${start}`;
        if (end) url += `&end=${end}`;
        url += `&page=${page}&per_page=${perPage}`;

        try {
            const response: AxiosResponse<ProductsInsightsReportDto> = await ApiClient.get(
                url,
                createTokenConfig(token!)
            );

            dispatch(getSuccess(convertToProductsInsightsReport(response.data)));
        } catch (apiError) {
            if (!isCancelled(apiError)) {
                dispatch(getError());
                dispatch(showError('Too many records to display. Please try a shorter date range.'));
            }
        }
    };
};

const getStart = (): ProductsInsightsReportAction => ({
    type: PRODUCTS_INSIGHTS_REPORT_GET_START
});

const getSuccess = (report: ProductsInsightsReport): ProductsInsightsReportAction => ({
    type: PRODUCTS_INSIGHTS_REPORT_GET_SUCCESS,
    payload: { report }
});

const getError = (): ProductsInsightsReportAction => ({
    type: PRODUCTS_INSIGHTS_REPORT_GET_ERROR
});
